// Routes owned by the Dayoffs module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const dayoffsPaths = {
    dayOffsManage: '/dayoffs',
    dayOffHRMList: '/dayoffs',
    dayOffAccountList: '/account/dayoffs',
    dayOffCreatePage: '/account/dayoffs/new',
    // Unreferenced: no paths.* caller; route is live (/dayoffs/:id).
    dayOffDetail: '/dayoffs/:id',
    dayOffEdit: '/account/dayoffs/:id/edit',
} as const
